import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, RefreshCw } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const tips = [
  "Relax your shoulders.",
  "Blink and look away from screen for 20s.",
  "Drink a glass of water.",
  "Take three deep breaths.",
  "Stand up and stretch for 30 seconds.",
  "Unclench your jaw.",
  "Adjust your posture.",
  "Smile at yourself in the mirror.",
  "Listen to one of your favorite songs.",
  "Write down one thing you are grateful for.",
];

const WellnessTip = () => {
  const [tip, setTip] = useState(() => {
    const randomIndex = Math.floor(Math.random() * tips.length);
    return tips[randomIndex] || "Take a deep breath.";
  });

  const getRandomTip = () => {
    const randomIndex = Math.floor(Math.random() * tips.length);
    setTip(tips[randomIndex] || "Take a deep breath.");
  };

  return (
    <Card className="h-full flex flex-col bg-white/40 backdrop-blur-md border-white/20 shadow-sm hover:shadow-md transition-all duration-300">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="w-5 h-5 text-primary" />
          Wellness Tip
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col justify-between pt-4">
        <div className="min-h-20 flex items-center justify-center text-center">
          <AnimatePresence mode="wait">
            <motion.p
              key={tip}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="text-xl font-medium text-primary"
            >
              "{tip}"
            </motion.p>
          </AnimatePresence>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={getRandomTip}
          className="mt-4 w-full text-muted-foreground hover:text-primary"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          New Tip
        </Button>
      </CardContent>
    </Card>
  );
};

export default WellnessTip;
